import React from 'react';
import * as ReactRedux from 'react-redux';
import {toast, ToastContainer} from 'react-toastify';

import 'react-toastify/dist/ReactToastify.css';
import store from 'store';
import {axios, venditshop} from '../../../index';
import {receiveLoadingUpdate, setUpdateMSG} from '../../../redux/actions';
import LoadingAnimation from '../../element/LoadingAnimation';
import ProductList from '../../element/ProductList';
import Body from '../fakerum/Body';
import Footer from '../fakerum/Footer';
import Header from '../fakerum/Header';
import Modal from '../fakerum/Modal';
import P1 from '../helper/P1';

class Sitebody extends React.PureComponent {
  constructor(props) {
    super(props);

    const infomodal = store.get('infomodal') || false;
    const cookiemodal = store.get('cookiemodal') || false;
    const distributionmodal = store.get('distmodal') || false;
    const fidWarnung = store.get('fidWarnung') || false;

    this.state = {
      visible: false,
      fade: false,
      message: null,
      infoModal: infomodal,
      cookiemodal : cookiemodal,
      distShown: distributionmodal,
      fidWarnung: fidWarnung,
      boersen: []
    };

    this.toastId = null;
    this.toastOrdersatz = null;
    this.loadDistributionBoersen = async () => {

      const result = await axios.post('/distribution/', {datum: null});
      return result;
    };

    this.saveSetting = async (value, setting) => {
      await axios.post((this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname :'')+'/customer/saveSettings/', {wert: value, setting: setting});
    };

  }

  async componentDidMount() {
    document.addEventListener('visibilitychange', () => {
      let hidden;
      if (typeof document.hidden !== 'undefined') {
        hidden = 'hidden';
      } else if (typeof document.msHidden !== 'undefined') {
        hidden = 'msHidden';
      } else if (typeof document.webkitHidden !== 'undefined') {
        hidden = 'webkitHidden';
      }
      if (document[hidden]) {
        this.props?.changeLoading(false);
      }
    });
    if (this.props?.meta?.licenseCache?.boersenDist && !this?.state?.boersen?.length) {
      let tmp = await this.loadDistributionBoersen();
      this.setState({boersen: tmp.data});
    }
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    if (this.props?.meta?.licenseCache?.ordersatzHinweis) {
      const prev = prevProps.ordersatzdata || {};
      const next = this.props.ordersatzdata || {};
      let message = null;
      if (next && next.produkttyp === 'a' && next.data) {
        const prevData = prev.data || {};
        const nextData = next.data;
        const prevArtikel = prevData.artikel || {};
        const nextArtikel = nextData.artikel || {};
        if ((prevArtikel.artikel !== nextArtikel.artikel || prev.menge !== next.menge) && next.menge) {
          let nextOrdersatz = nextData.ordersatz;
          if (nextOrdersatz) {
            nextOrdersatz = nextOrdersatz || {};
            const picmenge = nextOrdersatz.picmenge || 1;
            const durchschnittsmenge = nextOrdersatz.durchschnittsmenge || 0;
            const calcmenge = Math.round(durchschnittsmenge / picmenge, 2);
            const absDiff = Math.abs(Math.round(calcmenge - next.menge, 2));
            const abweichungDelta = Math.max(Math.round(calcmenge * 0.3, 2), 1);
            if (absDiff > abweichungDelta) {
              // Ordersatzmenge weicht ab
              const b = venditshop.helper.fix_euro_sign(nextArtikel.bezeichnung) || '';
              const c = calcmenge || 0;
              const n = next.menge || 0;
              message = `"${b}" weicht in Ihrem Ordersatz deutlich ab (⌀-Ordersatz: ${c} / Warenkorb ${n}).`;
            } else if (this.state.visible) {
              // Weicht nicht ab, keine Meldung / ausblenden, falls noch da
              // /
              // this.setState({visible: false, fade: false, message});
            }
          } else {
            // Artikel nicht im Ordersatz
            message =
              `"${venditshop.helper.fix_euro_sign(nextArtikel.bezeichnung) || ''}" befindet sich nicht in Ihrem Ordersatz.`;
          }
        }
      } else if (this.state.visible) {
        // this.setState({visible: false, fade: false, message});
      }

      //Hier mobile toastify
      if (message && this.props?.displayToast) {
        if (!toast.isActive(this.toastOrdersatz)) {
          this.toastOrdersatz = toast(message);
        }
      }
    }

    let message = null;
    if (this?.props?.message.length && this?.props?.updateMessage) {
      message = this.props.message;
      if (message && this.props?.displayToast) {
        if (!toast.isActive(this.toastId)) {
          this.toastId = toast(message);
        } else {
          toast.update(this.toastId, {render: message});
        }
      }
    }
    this.props.test();
  }

  render() {
    let modal = null;
    const meta = this.props?.meta || {};
    const force_login = !!meta?.force_login;
    const children = this.props.children;

    const stopBoerseModal = (this?.props?.settings?.find((e) => e.bezeichnung == 'stopshowingBoersenDistModal'));

    let stopBoerseModalWert = stopBoerseModal?.wert == 'true' || false;

    if (stopBoerseModalWert) {
      store.set('distmodal', true);
    }
    let infomodal;
    if (meta?.login && meta?.conf?.infomodal && this.props?.hasInfo?.infos != this.props?.hasInfo?.gelesen && !this.state?.infoModal) {
      infomodal = <Modal className='infoModal'>
        <Header>
          <h3>Informationen</h3>
        </Header>
        <Body>
          <P1>Sie haben noch {this.props?.hasInfo?.infos - this.props?.hasInfo?.gelesen} ungelesene Informationen.
            Klicken
            sie <a href={(this.props?.meta?.conf?.cssCompletePath ? props?.meta?.hostname :'')+'/info/'} onClick={() => {
              store.set('infomodal', true);
              this.setState({infoModal: true});
            }}><strong>hier</strong></a> um diese einzusehen!</P1>
        </Body>
        <Footer>
          <button className='ok' onClick={() => {
            store.set('infomodal', true);
            this.setState({infoModal: true});
          }}>OK
          </button>
        </Footer>
      </Modal>;
    }

    let cookiemodal;
    if (meta?.login && meta?.conf?.cookieHintAfterLogin && !this.state?.cookieModal
       && this.props?.showCookieHint
     ) {
      cookiemodal = <Modal className='infoModal'>
        <Header>
          <h3>Cookie</h3>
        </Header>
        <Body>
          <P1>Es werden nur technisch notwendige Cookies erhoben</P1>
        </Body>
        <Footer>
          <button className='ok' onClick={async () => {
            const p = await axios.post((this.props?.meta?.conf?.cssCompletePath ? this.props?.meta?.hostname :'')+'/customer/cookieHint/', {
              customer: this.props?.customer?.id
            });
            store.set('cookiemodal', true);
            this.setState({cookieModal: true});
          }}>OK
          </button>
        </Footer>
      </Modal>;
    }

    let distmodal;
    if (!this.state.distShown && meta?.licenseCache?.boersenDist && meta.login && this.state?.boersen && this.state?.boersen?.length && !stopBoerseModalWert) {
      distmodal = <Modal className='boerseDistModal'>
        <Header>
          <h3>Unsere speziellen Angebote für Sie</h3>
        </Header>
        <Body onClick={(e) => {

        }}>
          <ProductList
            {...meta.config}
            sortByCategory
            hideActionpanel
            hidePagination disableSort disableFilter uebersicht
            list={this.state?.boersen}/>
        </Body>
        <Footer>
          <button className='test left' onClick={async () => {
            await this.saveSetting('true', stopBoerseModal?.bezeichnung);
            store.set('distmodal', true);
            this.setState({distShown: true});
          }}>Nicht erneut anzeigen
          </button>
          <button className='test right' onClick={() => {
            store.set('distmodal', true);
            this.setState({distShown: true});
          }}>Zum Sortiment / Später
          </button>
        </Footer>
      </Modal>;
    }

    let fidWarnung;
    if (meta?.conf?.fidMeldung && meta.login && this.props?.fid === false && this.state?.fidWarnung === false) {
      fidWarnung = <Modal className='boerseDistModal'>
        <Header>
          <h3>Keine FID im Kundenkonto hinterlegt</h3>
        </Header>
        <Body onClick={(e) => {

        }}>
          Es ist keine FID in Ihrem Kundenkonto hinterlegt. Es können keine Track&Trance-pflichtigen Artikel bestellt werden.
        </Body>
        <Footer>
          <button className='test right' onClick={() => {
            store.set('fidWarnung', true);
            this.setState({fidWarnung: true});
          }}>Zum Sortiment
          </button>
        </Footer>
      </Modal>;
    }

    return <section className={'_Sitebody ' + (force_login ? 'force_login' : '')}>
      <div className='inner'>
        {children}
      </div>
      {modal}
      {distmodal}
      {cookiemodal}
      {fidWarnung}
      <ToastContainer progressClassName='progressToast' draggablePercent={40} pauseOnHover
                      className='toast-container'
                      position="bottom-right"
                      autoClose={5000}
                      toastClassName='toast'
                      draggable={this.props?.mobile}
                      closeOnClick={false}/>

      {this.props?.loading ? <LoadingAnimation/> : null}
      {infomodal}
    </section>;
  }
}

export default ReactRedux.connect((state) => ({
  ordersatzdata: state.ordersatzdata,
  meta: state.meta,
  mobile: state.mobile.isMobile,
  isBig: state.mobileBig,
  loading: state.loading,
  message: state.message,
  updateMessage: state.updateMessage,
  displayToast: state.displayToast
}), (dispatch) => ({
  changeLoading: (loading) => {
    dispatch(receiveLoadingUpdate(loading));
  },
  test: () => {
    dispatch(setUpdateMSG(false));
  }
}))(Sitebody);
